import '../style/Footer.css';

const quickLinks = [
  { label: 'TRA', href: 'https://www.tra.go.tz/' },
  { label: 'TPA', href: 'https://www.ports.go.tz/index.php/en/' },
  { label: 'TIC', href: 'https://www.tiseza.go.tz/' },
  { label: 'LATRA', href: 'https://www.latra.go.tz/' },
  { label: 'Weights & Measures', href: 'https://www.convert-me.com/en/' },
];

const socials = [
  { label: 'Facebook', href: '#', icon: 'facebook' },
  { label: 'Instagram', href: '#', icon: 'instagram' },
  { label: 'X', href: '#', icon: 'x' },
  { label: 'LinkedIn', href: '#', icon: 'linkedin' },
];

function SocialIcon({ type }) {
  if (type === 'facebook') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M13.5 8.5V6.9c0-.7.5-.9.8-.9h2.1V2.6h-2.9C10.7 2.6 9 4.3 9 7.2v1.3H6.8v3.5H9v9.1h4.5V12h2.9l.4-3.5h-3.3z" />
      </svg>
    );
  }
  if (type === 'instagram') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 7.2A4.8 4.8 0 1 0 12 16.8A4.8 4.8 0 1 0 12 7.2zm0 7.9a3.1 3.1 0 1 1 0-6.2a3.1 3.1 0 0 1 0 6.2z" />
        <path d="M16.9 3.8H7.1A3.3 3.3 0 0 0 3.8 7.1v9.8a3.3 3.3 0 0 0 3.3 3.3h9.8a3.3 3.3 0 0 0 3.3-3.3V7.1a3.3 3.3 0 0 0-3.3-3.3zm1.6 13.1c0 .9-.7 1.6-1.6 1.6H7.1c-.9 0-1.6-.7-1.6-1.6V7.1c0-.9.7-1.6 1.6-1.6h9.8c.9 0 1.6.7 1.6 1.6v9.8z" />
        <circle cx="17.2" cy="6.8" r="1.1" />
      </svg>
    );
  }
  if (type === 'linkedin') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6.6 8.8H3.1v11.1h3.5V8.8zM4.9 3.5a2 2 0 1 0 0 4a2 2 0 0 0 0-4zM20.9 13.5c0-3.2-1.7-4.8-4-4.8c-1.8 0-2.6 1-3 1.7v-1.5h-3.4c0 1 .1 11 .1 11h3.4v-6.1c0-.3 0-.6.1-.8c.2-.6.8-1.2 1.8-1.2c1.3 0 1.9 1 1.9 2.5v5.6h3.4v-6.4z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M14.2 10.6l6.5-7.6h-1.5l-5.7 6.6L8.9 3H3.8l6.9 10L3.8 21h1.5l6.1-7.1L16.2 21h5.1l-7.1-10.4zm-2 2.3l-.7-1L5.9 4h2.3l4.5 6.4l.7 1l5.9 8.5H17l-4.8-6.9z" />
    </svg>
  );
}

function ContactIcon({ type }) {
  if (type === 'email') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20 6H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 2v.5l-8 5l-8-5V8h16zM4 16V10.8l8 5l8-5V16H4z" />
      </svg>
    );
  }
  if (type === 'phone') {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6.6 10.8a15.6 15.6 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.2c1.1.4 2.3.6 3.6.6a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.8 21 3 13.2 3 4a1 1 0 0 1 1-1h3.4a1 1 0 0 1 1 1c0 1.3.2 2.5.6 3.6a1 1 0 0 1-.2 1l-2.2 2.2z" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2a7 7 0 0 0-7 7c0 4.8 6 12.2 6.3 12.5a1 1 0 0 0 1.4 0C13 21.2 19 13.8 19 9a7 7 0 0 0-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="Footer" id="contact" aria-label="Footer">
      <div className="Footer-top">
        <div className="Footer-grid">
          <section className="Footer-col Footer-brand">
            <img
              className="Footer-logo"
              src={`${process.env.PUBLIC_URL}/image/abstanLogo.png`}
              alt="Abstan Logistics logo"
            />

            <div className="Footer-socials" aria-label="Social media">
              {socials.map((item) => (
                <a key={item.label} href={item.href} aria-label={item.label}>
                  <SocialIcon type={item.icon} />
                </a>
              ))}
            </div>
          </section>

          <section className="Footer-col">
            <h3>Quick Links</h3>
            <ul className="Footer-links">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <a href={item.href} target="_blank" rel="noopener noreferrer">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <section className="Footer-col">
            <h3>Contact Us</h3>
            <div className="Footer-contact">
              <div className="Footer-contactRow">
                <span className="Footer-contactIcon" aria-hidden="true">
                  <ContactIcon type="email" />
                </span>
                <p>info@abstan.co.tz</p>
              </div>

              <div className="Footer-contactRow">
                <span className="Footer-contactIcon" aria-hidden="true">
                  <ContactIcon type="phone" />
                </span>
                <p>+255748400444</p>
              </div>

              <div className="Footer-contactRow Footer-contactRowAlignStart">
                <span className="Footer-contactIcon" aria-hidden="true">
                  <ContactIcon type="location" />
                </span>
                <p>
                  Harbour View Towers
                  <br />
                  4th Floor, Room No. 416,
                  <br />
                  Plot No.2317/108 and 2318/108,
                  <br />
                  Samora Avenue,
                  <br />
                  Dar es Salaam - Tanzania
                </p>
              </div>
            </div>
          </section>

          <section className="Footer-col">
            <h3>News Letter</h3>
            <p className="Footer-newsText">
              Subscribe to Our Updates and Newsletters.
            </p>
            <form className="Footer-newsForm" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Enter Your Email" aria-label="Email" />
              <button type="submit" aria-label="Submit newsletter">
                &#10148;
              </button>
            </form>
          </section>
        </div>
      </div>

      <div className="Footer-bottom">
        <p>Copyright &copy; 2026 ABSTAN LOGISTICS LIMITED. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

